export const subSessionStorageKey = 'sub';
export const signUpStateSessionStorageKey = 'signUpState';
export const paymentMethodStateSessionStorageKey = 'paymentMethodState';
export const hasShippingRequestsSessionStorageKey = 'hasShippingRequests';
